import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ModalComponent from '../../layout/Modals/ModalComponent/ModalComponent';
import {
  connectModalContainerContextToComponent,
} from '../../../contexts/ModalContext/ModalContext';

function ReferralRewardsModal({ setModalJSX }) {
  const [show, setShow] = useState(true);

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  return (
    <ModalComponent
      show={show}
      close={closeModalHandler}
      showConfirmCallToAction={false}
    >
      <Modal.Header closeButton>
        <Modal.Title><h3> Referral Discounts & Rewards</h3></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col">
          <h4>Referee Discount</h4>
          <p>
            When someone uses your referral code,
            they can save 5% on their order. (*
            <i>
              Referral discounts cannot be combined with other
              Room Alert discounts in the same purchase
            </i>
            .)
          </p>
          <h4>Referrer Reward</h4>
          <p>Your reward is based on the subtotal of their order:</p>
          <div className="table-responsive">
            <table className="table table-condensed table-striped small">
              <thead>
                <tr>
                  <th>Order Subtotal</th>
                  <th>Referrer Reward</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>$250 - $999</td>
                  <td>$10</td>
                </tr>
                <tr>
                  <td>$1,000 - $2,499</td>
                  <td>$25</td>
                </tr>
                <tr>
                  <td>$2,500 - $4,999</td>
                  <td>$50</td>
                </tr>
                <tr>
                  <td>$5,000 - $9,999</td>
                  <td>$100</td>
                </tr>
                <tr>
                  <td>$10,000 - $24,999</td>
                  <td>$250</td>
                </tr>
                <tr>
                  <td>$25,000 - $99,999</td>
                  <td>$500</td>
                </tr>
                <tr>
                  <td>$100,000+</td>
                  <td>$1000</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
}

ReferralRewardsModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
};

export { ReferralRewardsModal };
export default connectModalContainerContextToComponent(ReferralRewardsModal);
